import React from "react";
import PageHeader from "../components/PageHeader";

export default function Chairman() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Pages", link: "/pages" },
    { label: "Chairman", active: true },
  ];

  return (
    <>
    <div>
      {/* Page Header */}
      <PageHeader title="अध्यक्ष" breadcrumbs={breadcrumbs} />

      {/* Chairman Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-start">

            {/* Left: Photo */}
            <div className="col-lg-4 text-center">
              <div className="chairman-card">
                <img
                  src="/assests/img/members/Chairman_Dr_Amardeep.png"
                  alt="Chairman"
                  className="img-fluid rounded"
                />
                <h4 className="mt-3 mb-0">डॉ. अमरदीप</h4>
                <p className="text-primary fw-semibold">अध्यक्ष</p>
              </div>
            </div>

            {/* Right: Content */}
            <div className="col-lg-8">
              <div className="chairman-content">

                <div className="info-block">
                  <h6>व्यक्तिगत विवरण :</h6>
                  <p>
                    1 मार्च 1977 को मधेपुरा, बिहार में जन्म। दिल्ली विश्वविद्यालय से हिंदी साहित्य में एम.ए. (1998)। पीएच.डी. मगध विश्वविद्यालय से (2002)। शिक्षा, साहित्य, मीडिया और सामाजिक क्षेत्रों में सक्रिय।
                  </p>
                </div>

                <div className="info-block">
                  <h6>शिक्षा के क्षेत्र में कार्य : </h6>
                  <p>
                   2006 से मधेपुरा कॉलेज (बीएनएमयू), मधेपुरा के हिंदी विभाग में प्रोफेसर। बीएनएमयू, मधेपुरा के सीनेट के सदस्य। साहित्य एवं विभिन्न विषयों पर अनेक महत्वपूर्ण पुस्तकों का प्रकाशन। विभिन्न राज्यों में कंप्यूटर शिक्षा के प्रसार हेतु 30 शैक्षिक सॉफ्टवेयर (ई-बुक्स) का निर्माण।
                  </p>
                </div>

                <div className="info-block">
                  <h6>लेखन कार्य :</h6>
                  <p>
                    दस वर्ष की आयु में पहला कविता संग्रह प्रकाशित। प्रतिष्ठित पत्रिकाओं एवं समाचार पत्रों में नियमित रूप से रचनाएँ प्रकाशित करना, स्तम्भ लेखन, विभिन्न विषयों पर निबंध एवं शोध पत्रों का प्रकाशन। अब तक कविता, निबंध, आलोचना और शोध की कुल 10 पुस्तकें प्रकाशित।
                  </p>
                </div>

                <div className="info-block">
                  <h6>मीडिया में कार्य :</h6>
                  <p>
                    समाचार चैनल 'वॉयस ऑफ नेशन' देहरादून और आर्यन न्यूज, पटना के क्रिएटिव हेड। दूरदर्शन के लिए तीन धारावाहिकों पर हस्ताक्षर किये। विभिन्न समाचार चैनलों और आकाशवाणी के लिए कार्यक्रमों का लेखन, निर्देशन और निर्माण। मीडिया प्रोडक्शन हाउस 'मीडिया 21' एवं न्यूज पोर्टल 'बोल बिहार' का संचालन।
                  </p>
                </div>

                <div className="info-block">
                  <h6>पुरस्कार/सम्मान :</h6>
                  <p>
                   1998 में राजभाषा विभाग, बिहार सरकार द्वारा सम्मानित। 1990 में साहित्यकार रमण ट्रस्ट, पटना द्वारा रमण साधना पुरस्कार एवं स्वर्ण पदक। 1993 में केंद्रीय हिंदी निदेशालय, मानव संसाधन विकास मंत्रालय, भारत सरकार द्वारा विभिन्न साहित्यिक प्रयोजनों हेतु 'स्मृति-श्रृंगार' कृति का चयन। 1994 में दिल्ली विश्वविद्यालय में रचनात्मक लेखन प्रतियोगिता में प्रथम स्थान। 1996 में बिहार राष्ट्रभाषा परिषद द्वारा नवोदित साहित्यकार पुरस्कार। 1996 में दिल्ली विश्वविद्यालय द्वारा हिंदी साहित्य में योगदान के लिए सम्मानित।
                  </p>
                </div>

                <div className="info-block">
                  <h6>विशेष उल्लेख :</h6>
                  <p>
                    2021-22 में भारत सरकार के इस्पात मंत्रालय की हिंदी सलाहकार समिति के सदस्य। भारत सरकार के सूचना एवं प्रसारण मंत्रालय के विज्ञापन एवं दृश्य प्रचार निदेशालय (डीएवीपी) में कार्यकारी निर्माता के रूप में कार्य किया (1998-2003)। 1995-96 में किरोड़ीमल कॉलेज (डीयू) में हिंदी परिषद के सचिव और अध्यक्ष रहे। मीडिया, सॉफ्टवेयर और प्रकाशन से संबंधित कई संस्थानों की स्थापना।
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    </>
  );
}
